import { PortfolioChartFilter } from '@/modules/wealth/services/portfolio';

export const getFilterOptions = (options: PortfolioChartFilter[]) => {
  return options.map(option => ({
    ...option,
    value: option.key
  }));
};
